import React from 'react';

import Checkpoint from 'shared/components/Checkpoint';
import PopOverModal from 'shared/components/Modals/PopOverModal';

import styles from './styles.module.scss';

const POINTS = [
  'Enter your score to reveal all scores and averages',
  'Compare one company against others',
  'Build a risk profile for your tech procurement'
];

const MaturityMatrixExplanationModal = ({ toggleExplanationModal }) => (
  <PopOverModal
    closeModal={toggleExplanationModal}
    withoutHeaderBorder={true}
    className={styles.container}>
    <div className={styles.title}>What is Uniscore?</div>
    <div className={styles.description}>
      Our propriety tool lets you see how innovative, and widely adopted, our
      users think this PropTech company is.
    </div>

    <div className={styles.divider} />

    {POINTS.map(text => (
      <Checkpoint className={styles.point} iconClassNames={styles.icon}>
        {text}
      </Checkpoint>
    ))}
  </PopOverModal>
);

export default MaturityMatrixExplanationModal;
